export function Footer() {
  return (
    <footer className="border-t border-border bg-bg">
      <div className="mx-auto max-w-6xl px-6 py-8 text-sm text-fg-2">
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-fg-muted">
          <span>© {new Date().getFullYear()} 观微 · FateLens</span>
        </div>
      </div>
    </footer>
  );
}
